/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { ColorAlias, getThemeColorFromAlias, theme } from "../../theme";

interface DownloadIconProps {
  color: ColorAlias;
}

const DownloadIcon: FC<DownloadIconProps> = ({ color }) => {
  const iconColor = getThemeColorFromAlias(color, theme.colors);

  return (
    <svg
      width="30"
      height="20"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 27L28 27"
        stroke={iconColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M13.9393 22.0607C14.5251 22.6464 15.4749 22.6464 16.0607 22.0607L25.6066 12.5147C26.1924 11.9289 26.1924 10.9792 25.6066 10.3934C25.0208 9.80761 24.0711 9.80761 23.4853 10.3934L15 18.8787L6.51472 10.3934C5.92893 9.80761 4.97919 9.80761 4.3934 10.3934C3.80761 10.9792 3.80761 11.9289 4.3934 12.5147L13.9393 22.0607ZM16.5 2C16.5 1.17157 15.8284 0.5 15 0.5C14.1716 0.5 13.5 1.17157 13.5 2H16.5ZM16.5 21V2H13.5L13.5 21H16.5Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default DownloadIcon;
